import { render, staticRenderFns } from "./SysTzList.vue?vue&type=template&id=0fa27680&xmlns%3Av-bind=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./SysTzList.vue?vue&type=script&lang=js"
export * from "./SysTzList.vue?vue&type=script&lang=js"
import style0 from "./SysTzList.vue?vue&type=style&index=0&id=0fa27680&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports